import { jsx } from 'react/jsx-runtime';
import style from './HeaderContainer.module.css.js';

const HeaderContainer = ({ children }) => {
    return jsx("div", { className: style.container, children: children });
};

export { HeaderContainer };
//# sourceMappingURL=HeaderContainer.js.map
